export default __webpack_public_path__ + "static/MIC_social-f43d900df2b1aec637b4e05a6f29408f.jpg";